import styles from '../SegmentVisualBuilder.module.css';
import type { DateValueMode } from './types';

export function DateValueModeToggle({
  dateValueMode,
  onChange,
  disabled,
}: {
  dateValueMode: DateValueMode;
  onChange: (dateValueMode: DateValueMode) => void;
  disabled?: boolean;
}) {
  const isRelative = dateValueMode === 'relative';
  const isAbsolute = dateValueMode === 'absolute';

  return (
    <div className={styles.dateVariantToggle} role="group" aria-label="Date type">
      <button
        type="button"
        className={isRelative ? styles.dateVariantBtnActive : styles.dateVariantBtn}
        onClick={() => onChange('relative')}
        aria-pressed={isRelative}
        disabled={disabled}>
        Relative
      </button>
      <button
        type="button"
        className={isAbsolute ? styles.dateVariantBtnActive : styles.dateVariantBtn}
        onClick={() => onChange('absolute')}
        aria-pressed={isAbsolute}
        disabled={disabled}>
        Absolute
      </button>
    </div>
  );
}
